import PropTypes from "prop-types";
import React from 'react';
import { useState, useEffect, useCallback } from "react";
import { RefreshCw } from "lucide-react";
import { getProductos, updateProductoById, deleteProductoById, getMaterial, getMarcas, getFamilias, getFacturas, getUbicacion, getEmpleados} from "../api";

const NuevoCatalogo = ({ empleado }) => {
  const [productos, setProductos] = useState([]);
  const [filteredProducto, setFilteredProducto] = useState([]);
  const [error, setError] = useState("");
  const [filterText, setFilterText] = useState("");

  
  const fetchDropdownData = async () => {
    try {
      await Promise.all([
        getMaterial(),
        getUbicacion(),
        getEmpleados(),
        getFacturas(),
        getMarcas(),
        getFamilias(),
      ]);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };


  const fetchProducto = useCallback(async () => {
    try {
      const response = await getProductos();
      const data = response.data;
  
      setProductos((prev) =>
        JSON.stringify(prev) === JSON.stringify(data) ? prev : data
      );
    } catch (error) {
      console.error("Error fetching producto:", error);
      setError("Error loading data");
    }
  }, []);
  

  useEffect(() => {
    fetchProducto();
    fetchDropdownData();
  }, [fetchProducto]);

  useEffect(() => {
    if (filterText) {
      const filtered = productos.filter((Producto) =>
        Producto.id?.toString().includes(filterText.toLowerCase()) ||
        Producto.descripcion?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.color?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.marca?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.familia?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.estado?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.familia_tipo?.toLowerCase().includes(filterText.toLowerCase()) ||
        Producto.codigo?.toLowerCase().includes(filterText.toLowerCase()) ||
        (Producto.creado_por || "").toLowerCase().includes(filterText.toLowerCase())
      );
      setFilteredProducto(filtered);
    } else {
      setFilteredProducto(productos);
    }
  }, [filterText, productos]);

  const handleReturn = async (producto) => {
    try {
      const formDataToSend = new FormData();
      const ubicacionTemporal = "1"; // cambia por el ID real de ubicación temporal
      formDataToSend.append("regresar", "true");
      formDataToSend.append("id_ubicacion", ubicacionTemporal);

      await updateProductoById(producto.id, formDataToSend);
      alert("Producto actualizado con éxito.");
      fetchProducto();
    }catch (error) {
      console.error("Error procesando el producto:", error);
    }
  };
   
  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar esta producto?")) {
      try {
        await deleteProductoById(id);
        alert("Producto eliminado con éxito.");
        fetchProducto();
      } catch (error) {
        console.error("Error eliminando la producto:", error);
      }
    }
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por id, descripción, materia o familia..."
          className="input3"
          style={{ flex: 1 }}
        />
        <button
          onClick={fetchProducto}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "25px",
            padding: 0,
            marginLeft: "10px"
          }}
          title="Actualizar productos"
        >
          <RefreshCw size={24} />
        </button>
      </div>
      <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#cffbd1", border: "1px solid #aaa" }}></div>
          <span>ENTRADA</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#93c1ff", border: "1px solid #aaa" }}></div>
          <span>SALIDA</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#ffb4b4", border: "1px solid #aaa" }}></div>
          <span>EQ. DAÑADOS</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#a67eff", border: "1px solid #aaa" }}></div>
          <span>DESTRUCCIÓN</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#ffc17e", border: "1px solid #aaa" }}></div>
          <span>RENTA</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#c93328", border: "1px solid #aaa" }}></div>
          <span>EXTRAVIADO</span>
        </div>
      </div>

      {filteredProducto.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
      <table className="table">
        <thead>
          <tr>
            <th>#</th>
            <th>#DB</th>
            <th>Código</th>
            <th>Descripción (Estado)</th>
            <th>Estado</th>
            <th>Familia</th>
            <th>Marca</th>
            <th>Tipo</th>
            <th>Ubicación</th>
            <th>Cantidad</th>
            <th>Color</th>
            <th>Nota</th>
            <th>Proveedor-Factura</th>
            <th>Creación</th>
            <th>Responsable</th>
            <th>Última Actualización</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducto.slice(0, 1000).map((producto, i) => {
            const rowStyle = {
              backgroundColor: 
                producto.estado === "ENTRADA" ? "#cffbd1" :
                producto.estado === "SALIDA" ? "#93c1ff" :
                producto.estado === "EQ. DAÑADOS" ? "#ffb4b4" :
                producto.estado === "DESTRUCCION" ? "#a67eff" :
                producto.estado === "RENTA" ? "#ffc17e" :
                "#dcdcdc", // Default color
              fontSize: "15px"
            };

            return (
            <tr key={producto.id} style={rowStyle}>
              <td >{i+1}</td>
              <td>{producto.id}</td>
              <td>{producto.codigo}</td>
              <td>{producto.descripcion} ({producto.estado})</td>
              <td>{producto.estado}</td>
              <td>{producto.familia}</td>
              <td>{producto.marca}</td>
              <td>{producto.familia_tipo}</td>
              <td>{producto.ubicacion}</td>
              <td>{producto.cantidad}</td>
              
              <td>{producto.color}</td>
              <td>{producto.nota}</td>
              <td>{producto.rfc_cliente_proveedor}-{producto.folio_fiscal}</td>
              <td>{producto.fecha_creacion}</td>
              <td>{producto.creado_por}</td>
              <td>{producto.fecha_ultima_actualizacion}</td>
            </tr>
            );
          })}
        </tbody>
      </table>

      )}
    </div>
    
  );
};

NuevoCatalogo.propTypes = {
  producto: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default NuevoCatalogo;
